import EsriLayer from '../esri-layer/esri-layer.model';
import SpatialReference from '../spatial-reference/spatial-reference.model';

export default class EsriLayerList {
    public currentVersion = 0;
    public serviceDescription = '';
    public mapName = '';
    public description = '';
    public copyrightText = '';
    public supportsDynamicLayers = false;
    public layers: EsriLayer[] = [];
    public tables: string[] = [];
    public spatialReference: SpatialReference = new SpatialReference();

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.currentVersion) {
            this.currentVersion = model.currentVersion;
        }
        if (model.serviceDescription) {
            this.serviceDescription = model.serviceDescription;
        }
        if (model.mapName) {
            this.mapName = model.mapName;
        }
        if (model.description) {
            this.description = model.description;
        }
        if (model.copyrightText) {
            this.copyrightText = model.copyrightText;
        }
        if (model.supportsDynamicLayers) {
            this.supportsDynamicLayers = model.supportsDynamicLayers;
        }
        if (model.layers) {
            this.layers = [];
            for (let i = 0; i < model.layers.length; i++) {
                this.layers.push(new EsriLayer(model.layers[i]));
            }
        }
        if (model.tables) {
            this.tables = model.tables;
        }
        if (model.spatialReference) {
            this.spatialReference = new SpatialReference(model.spatialReference);
        }
    }

    apiObject() {
        return {
            layers: this.layers
        };
    }
}
